<div class="page-header" data-testid="page-header-component-div">
  <div class="nav-items items-center">
    @if (breadCrumbTree().length) {
      <button class="nav-item">
        <span (click)="routeToMain()">Scootaverses</span>
        @if (scootaverseName) {
          <span (click)="routeToScootaverse()">
            {{ checkScootaverseName(scootaverseName) }}
          </span>
        }
        @if (scootaverseId) {
          @for (breadcrumbItem of breadCrumbTree(); track breadcrumbItem.title) {
            <span [ngClass]="{ 'empty-click': $last }" (click)="$last ? null : routeTo(breadcrumbItem)">{{
              getTitle(breadcrumbItem)
            }}</span>
          }
        }
      </button>
    }
  </div>
  <div class="create-actions items-center">
    @if (isEntryFlowActive()) {
      <app-home-button data-testid="create-entry-flow-button" color="secondary" (click)="createEntryFlow()"
        >Create New Entry Flow</app-home-button
      >
    } @else {
      <app-home-button data-testid="create-scootaverse-button" color="secondary" (click)="createScootaverse()"
        >Create Scootaverse</app-home-button
      >
    }
  </div>
</div>
